<!-- 项目文件 -->
<template>
    <div class="w100p fs0">
        <!-- <img class="imgauto" :src="img" alt=""> -->
         <van-image lazy-load class="imgauto" :src="img" />
    </div>
</template>

<script>
    export default {
        props: ['img', ],
        data() {
            return {

            };
        },
        components: {

        },
        methods: {

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>

</style>